import {
  captureAnalyticsEvent,
  identifyAnalyticsUser,
  initErrorReporter,
  initPerformanceMonitor,
  initPostHog,
  initSentryReact,
  resetAnalytics,
  setOrganizationContext,
  setSentryUserContext,
  setUserContext,
} from '@sazeo/observability';
import { buildFunctionUrl } from '@sazeo/sdk';

type TenantObservabilityUser = {
  userId: string;
  tenantId?: string | null;
  plan?: string | null;
  role?: string | null;
};

const APP_NAME = 'tenant-app';

export function initTenantObservability() {
  initSentryReact({
    appName: APP_NAME,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENV ?? import.meta.env.VITE_STAGE,
    release: import.meta.env.VITE_GIT_SHA,
  });

  initPostHog({
    appName: APP_NAME,
    apiKey: import.meta.env.VITE_POSTHOG_KEY,
    apiHost: import.meta.env.VITE_POSTHOG_HOST,
    autocapture: false,
    capturePageview: false,
  });

  initErrorReporter({
    endpoint: buildFunctionUrl('client-errors'),
    appVersion: import.meta.env.VITE_GIT_SHA ?? 'unknown',
    appName: 'tenant-app',
    service: 'tenant-app',
    environment: import.meta.env.VITE_STAGE,
    releaseId: import.meta.env.VITE_GIT_SHA,
    gitCommitSha: import.meta.env.VITE_GIT_SHA,
  });

  initPerformanceMonitor();
}

export function setTenantObservabilityUser(user: TenantObservabilityUser | null) {
  if (!user) {
    setSentryUserContext(null);
    setUserContext(null);
    setOrganizationContext(null);
    resetAnalytics();
    return;
  }

  setSentryUserContext({
    userId: user.userId,
    tenantId: user.tenantId ?? null,
  });

  setUserContext({ userId: user.userId, role: user.role ?? null });

  if (user.tenantId) {
    setOrganizationContext({ organizationId: user.tenantId });
  }

  identifyAnalyticsUser(user.userId, {
    tenant_id: user.tenantId ?? undefined,
    plan: user.plan ?? undefined,
  });
}

export function captureTenantEvent(
  event: string,
  properties?: Record<string, string | number | boolean | null | undefined>,
) {
  captureAnalyticsEvent(event, properties);
}
